export enum TypeformSurvey {
  AiCreditPurchase = 'yYJ9SaEF'
}
